import { render, staticRenderFns } from "./BarraLateralBotao.vue?vue&type=template&id=5647b851&scoped=true&"
import script from "./BarraLateralBotao.vue?vue&type=script&lang=js&"
export * from "./BarraLateralBotao.vue?vue&type=script&lang=js&"
import style0 from "./BarraLateralBotao.vue?vue&type=style&index=0&id=5647b851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5647b851",
  null
  
)

export default component.exports